import apiService from './api';

export interface LessonPlanTemplate {
    id: string;
    title: string;
    description: string;
    content: string; // JSON or text content
    file_url?: string;
    subject_id?: string;
    grade_id?: string;
    subject_name?: string;
    created_by_name?: string;
    is_active: boolean;
    created_at: string;
}

export interface TemplateParams {
    page?: number;
    limit?: number;
    search?: string;
    subject_id?: string;
    grade_id?: string;
    is_active?: boolean;
}

export const templateService = {
    async getAll(params: TemplateParams = {}) {
        const queryParams = new URLSearchParams();
        if (params.page !== undefined) queryParams.append('page', String(params.page));
        if (params.limit !== undefined) queryParams.append('limit', String(params.limit));
        if (params.search) queryParams.append('search', params.search);
        if (params.subject_id) queryParams.append('subject_id', params.subject_id);
        if (params.grade_id) queryParams.append('grade_id', params.grade_id);
        if (params.is_active !== undefined) queryParams.append('is_active', String(params.is_active));

        return apiService.get<{ data: LessonPlanTemplate[], total: number, page: number, limit: number }>(`/api/lesson-plan-templates?${queryParams.toString()}`);
    },

    async getById(id: string) {
        return apiService.get<LessonPlanTemplate>(`/api/lesson-plan-templates/${id}`);
    },

    async create(data: Partial<LessonPlanTemplate>) {
        return apiService.post<LessonPlanTemplate>('/api/lesson-plan-templates', data);
    },

    async update(id: string, data: Partial<LessonPlanTemplate>) {
        return apiService.put<LessonPlanTemplate>(`/api/lesson-plan-templates/${id}`, data);
    },

    async delete(id: string) {
        return apiService.delete<{ message: string }>(`/api/lesson-plan-templates/${id}`);
    }
};
